import React, { useCallback } from 'react';

import {
  analyticsCalculatorRegExp,
  mathSymbolsRegExp,
} from '../../../../constants/regular-expressions';
import { MathUtils } from '../../../../utils/math-utils';
import { isCompliteNumberRegex } from '../../is-complite-number-regex';
import { inputUtils } from '../input-utils';
import { SearchItemsWithDropdownList } from '../search-items-with-dropdown-list';
import { PropertyFormat } from './constants';


const INPUT_VALUE = {
  Plus: '+',
  Minus: '-',
};

export const InputSelectNewOption = (props) => {
  const {
    elements,
    activeElementIndex,
    closeAfterClick = false,
    maxItemsAmount = 5,
    onClick,
    onBlur,
    value,
    format,
  } = props;

  const saveChangesState = React.useMemo(() => ({ selectedByClick: false }), []);

  const onClickCallback = React.useCallback((id) => {
    saveChangesState.selectedByClick = true;
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    setInputString('');
    const elementIndex = elements.indexOf(id);
    onClick(elementIndex)
  }, [onClick, elements]);

  const {
    setInputString,
    inputString,
    isDropdownOpen,
    onOpenDropdown,
    innerSideRef,
    onClickArrowContainer,
    onClickDropDownTextItem,
    filteredElements,
  } = inputUtils(closeAfterClick, onClickCallback, elements);
  const activeElement = elements[activeElementIndex];
  const inputRegExp = format === PropertyFormat.Text
    ? analyticsCalculatorRegExp
    : mathSymbolsRegExp;
  const onChangeHandler = useCallback(
    (e) => {
      if (!inputRegExp.test(e.target.value)) {
        if (
          format !== PropertyFormat.Text &&
          e.target.value &&
          isCompliteNumberRegex(e.target.value)
        ) {
          const numberValue = Number(e.target.value);
          if (!Number.isNaN(numberValue)) {
            setInputString(MathUtils.floor(numberValue, 6).toString());
          } else if (e.target.value === INPUT_VALUE.Plus || e.target.value === INPUT_VALUE.Minus) {
            setInputString(e.target.value);
          }
        } else {
          setInputString(e.target.value);
        }
      }
    },
    [inputString, activeElement]
  );

  const onInputBlur = useCallback(
    () => {
      // eslint-disable-next-line lodash/prefer-lodash-method
      const isInvalidValue = inputString.trim().length === 1 && (
        inputString === INPUT_VALUE.Plus || inputString === INPUT_VALUE.Minus
      )
      if (saveChangesState.selectedByClick || isInvalidValue) {
        saveChangesState.selectedByClick = false;
        return;
      }
      if (inputString) {
        onBlur(inputString);
      }
    },
    [onBlur, inputString]
  );

  const activeElementValue = value === undefined || value === null
    ? activeElement
    : value;

  return (
    <SearchItemsWithDropdownList
      isDropdownOpen={isDropdownOpen}
      onOpenDropdown={onOpenDropdown}
      innerSideRef={innerSideRef}
      onChangeValue={onChangeHandler}
      activeElement={activeElementValue}
      inputValue={inputString}
      onInputBlur={onInputBlur}
      onClickArrowContainer={onClickArrowContainer}
      elements={elements}
      filteredElements={filteredElements}
      maxItemsAmount={maxItemsAmount}
      onClickDropDownTextItem={onClickDropDownTextItem}
      isShowNewValue={true}
    />
  );
};
